"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentToken = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentToken = function getAgentToken(_ref) {
  var token = _ref.token;
  var headers = {};

  var _JSON$parse = JSON.parse(localStorage.getItem('config')),
      storeToken = _JSON$parse.storeToken,
      apiUrl = _JSON$parse.apiUrl,
      envId = _JSON$parse.envId,
      locale = _JSON$parse.locale;

  var isAuthStoredWithCookies = storeToken == 'cookies';
  if (isAuthStoredWithCookies) headers['X-CSRF-TOKEN'] = _jsCookie.default.get('X-CSRF-TOKEN');else headers.accesstoken = token;
  return (0, _axios.default)({
    url: "".concat(apiUrl, "/coreapp/coreAppAgentToken?locale=").concat(locale, "&envId=").concat(envId),
    method: 'GET',
    headers: headers,
    withCredentials: isAuthStoredWithCookies
  }).then(function (res) {
    console.log('res:', res);
    return res.data;
  }).catch(function (error) {
    console.log('error', error);
    throw error.response;
  });
};

exports.getAgentToken = getAgentToken;